export { useDrillPageStrokeViewSize } from "#use-drill-page-stroke-view-size";
